import { App } from 'antd';
import { useEffect } from 'react';

import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

type AntdAppInstances = {
  modal: Omit<ModalStaticFunctions, 'warn'>;
  message: MessageInstance;
  notification: NotificationInstance;
};

let antdAppRef: AntdAppInstances | null = null;

export function getAntdApp(): AntdAppInstances {
  if (!antdAppRef) {
    throw new Error(
      'antd App context is not available. Ensure AntdAppBridge is mounted inside AntdConfigProvider.',
    );
  }
  return antdAppRef;
}

export function AntdAppBridge() {
  const app = App.useApp();

  useEffect(() => {
    antdAppRef = {
      modal: app.modal,
      message: app.message,
      notification: app.notification,
    };

    return () => {
      antdAppRef = null;
    };
  }, [app]);

  return null;
}
